import styled from 'styled-components';

export const Container = styled.div`
  width: 88%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem;
  border-radius: 1.5rem;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 1px 9px #00000029;

  .header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    h1 {
      font-size: 1.2rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary};
    }

    a {
      font-size: 1.1rem;
      display: flex;
      color: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .containerAct {
    width: 100%;
    display: flex;
    position: relative;

    button {
      padding: 0;
      text-decoration: underline;
      text-transform: none;
      font-size: 1rem;
      font-weight: 300;
    }

    .map {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: -14rem;
      top: 1rem;
      background: ${({ theme }) => theme.colors.background_white};
      padding: 0.5rem;
      border-radius: 1rem;
      box-shadow: 0px 1px 9px #00000029;
      z-index: 10;
      max-height: 30rem;
      overflow-y: scroll;

      .header {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        button {
          color: #fff;
          background-color: ${({ theme }) => theme.colors.tertiary_500};
          width: 20px;
          height: 19px;
          border-radius: 100%;
          padding: 0;
          border: none;

          :hover {
            cursor: pointer;
          }
        }
      }

      .containerStates {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        h1 {
          font-size: 1.2rem;
          font-weight: 600;
          color: ${({ theme }) => theme.colors.primary};
          text-decoration: underline;
        }
      }

      .containerCities {
        display: flex;
        gap: 0.5rem;
        flex-wrap: wrap;

        p {
          display: flex;
          font-size: 1rem;
          font-weight: 400;
          color: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }

  .service {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;

    h1 {
      display: flex;
      font-size: 1.2rem;
      font-weight: 600;
      align-items: center;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .classificationDiamond {
      display: flex;

      img {
        width: 2.5rem;
        height: 2.5rem;
        margin-right: 0.2rem;
      }
    }

    .allService {
      display: -webkit-box;
      gap: 0.2rem;

      .numberServices {
        color: ${({ theme }) => theme.colors.black};
      }

      .labelCorrespondence {
        color: ${({ theme }) => theme.colors.gray_275};
        margin-left: 0.2rem;
      }
    }
  }

  .summary {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    h1 {
      font-size: 1.2rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary};
    }
    .containerPresentation {
      display: flex;
      max-width: 25rem;
      max-height: 5rem;
      overflow-y: auto;
      overflow-x: hidden;
      p {
        font-size: 1rem;
        font-weight: 450;
        color: ${({ theme }) => theme.colors.text};
        display: block;
      }
    }
  }

  .socialMedias {
    display: flex;
    margin-top: 1rem;
    gap: 0.5rem;

    button {
      background: ${({ theme }) => theme.colors.yellow_200};
    }
  }

  @media (max-width: 767px) {
    width: -webkit-fill-available;
    min-height: 200px;
    margin: 0 5px 0 5px;

    .summary {
      max-height: 96px;
      overflow-y: scroll;
    }

    .socialMedias {
      width: 100%;
      justify-content: center;
    }

    .containerAct .map {
      right: 0;
      top: 2rem;
    }
  }

  @media (max-width: 300px) {
    .socialMedias {
      width: 100%;
      justify-content: space-between;
    }
  }
`;
